/**
 * CabinetLayout — общий layout ЛК (header + main).
 *
 * Header: логотип + имя родителя + кнопка выхода.
 * Без сайдбара (это клиентский ЛК, не админка).
 */
import React from 'react';
import { Container, Group, Box, Text, ActionIcon, Tooltip } from '@mantine/core';
import { IconLogout } from '@tabler/icons-react';
import { useNavigate } from 'react-router-dom';
import { useParentSession } from '../context/ParentSessionContext';
import tokens from '../theme/designTokens';

const CabinetLayout = ({ children }) => {
  const { user, logout } = useParentSession();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  const fullName = user
    ? [user.first_name, user.last_name].filter(Boolean).join(' ') || user.email
    : '';

  return (
    <Box style={{ minHeight: '100vh', background: tokens.colors.bg.page }}>
      {/* Header */}
      <Box
        component="header"
        style={{
          position: 'sticky',
          top: 0,
          zIndex: 200,
          background: 'rgba(242,240,248,0.92)',
          backdropFilter: 'blur(20px)',
          borderBottom: `2px solid rgba(124,58,237,0.1)`,
          height: 68,
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <Container size="lg" style={{ width: '100%' }}>
          <Group justify="space-between" align="center">
            {/* Логотип */}
            <Box
              onClick={() => navigate('/')}
              style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 10 }}
            >
              <Box
                style={{
                  width: 38,
                  height: 38,
                  borderRadius: 12,
                  background: tokens.gradients.hero,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: 'white',
                  fontFamily: tokens.typography.fontFamilyHeading,
                  fontWeight: 1000,
                  fontSize: 18,
                  boxShadow: '0 4px 12px rgba(124,58,237,0.3)',
                }}
              >
                ЭИ
              </Box>
              <Box>
                <Text
                  style={{
                    fontFamily: tokens.typography.fontFamilyHeading,
                    fontWeight: 1000,
                    fontSize: 16,
                    color: tokens.colors.text.primary,
                    lineHeight: 1.1,
                  }}
                >
                  Это <span style={{ color: tokens.colors.brand.orange }}>Интересно!</span>
                </Text>
                <Text size="xs" style={{ color: tokens.colors.text.muted, fontWeight: 700 }}>
                  Личный кабинет
                </Text>
              </Box>
            </Box>

            {/* Имя + выход */}
            {user && (
              <Group gap="sm" align="center">
                <Box style={{ textAlign: 'right' }}>
                  <Text
                    size="sm"
                    fw={900}
                    style={{
                      color: tokens.colors.text.primary,
                      fontFamily: tokens.typography.fontFamilyHeading,
                    }}
                  >
                    {fullName}
                  </Text>
                  <Text size="xs" style={{ color: tokens.colors.text.muted, fontWeight: 700 }}>
                    {user.email}
                  </Text>
                </Box>
                <Tooltip label="Выйти">
                  <ActionIcon
                    variant="subtle"
                    color="brand-purple"
                    radius="xl"
                    size="lg"
                    onClick={handleLogout}
                  >
                    <IconLogout size={20} />
                  </ActionIcon>
                </Tooltip>
              </Group>
            )}
          </Group>
        </Container>
      </Box>

      {/* Main content */}
      <Box component="main" py="xl">
        <Container size="lg">
          {children}
        </Container>
      </Box>
    </Box>
  );
};

export default CabinetLayout;
